import React, { Component } from "react";
import { Button, Row, Image, Col } from "react-bootstrap";

class OrderLocation extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div
            style={{
              border: "1px solid #E0E0E0",
              padding: "3%",
              borderRadius: "5px 0px 0px 5px",
            }}
          >
            <table>
              <thead>
                <tr>
                  <th style={{ width: "10%" }}>Order Type</th>
                  <th style={{ width: "50%" }}>Name Request No.</th>
                  <th style={{ width: "40%" }}>ETA</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ width: "10%" }}>
                    <img
                      src={require("../../../../../assets/images/superadmin/ordericon/takeaway.svg")}
                      width="35px"
                    />
                  </td>
                  <td style={{ width: "50%" }}>
                    Alexander Petersburg <br />
                    #1234567890
                  </td>
                  <td
                    style={{ width: "40%" }}
                    style={{
                      color: "#EE3A23",
                      font: "normal normal bold 18px/22px Roboto",
                    }}
                  >
                    12:15:22
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            style={{
              border: "1px solid #E0E0E0",
              padding: "4%",
              borderRadius: "5px 0px 0px 5px",
            }}
          >
            <Row>
              <Col md={3}></Col>
              <Col md={6}>
                <div
                  align="center"
                  className="more-actions-orders-desc justify-content-center d-flex align-items-center mb-2"
                >
                  <Button
                    variant="link"
                    className="enIconBtn mr-3 action_icon_padding"
                    // onClick={props.ratingReviewAction}
                  >
                    <Image
                      src={require("../../../../../assets/images/superadmin/ordericon/call.svg")}
                      alt="Call"
                      title="Call"
                      fluid
                    />
                  </Button>
                  <Button
                    variant="link"
                    className="enIconBtn mr-3 action_icon_padding"
                  >
                    <Image
                      src={require("../../../../../assets/images/superadmin/ordericon/mail.svg")}
                      alt="Mail"
                      title="Mail"
                      fluid
                    />
                  </Button>{" "}
                  <Button
                    variant="link"
                    className="enIconBtn mr-3 action_icon_padding"
                    // onClick={props.ratingReviewAction}
                  >
                    <Image
                      src={require("../../../../../assets/images/superadmin/ordericon/Notifications.svg")}
                      alt="Notify"
                      title="Notify"
                      fluid
                    />
                  </Button>
                  <Button
                    variant="link"
                    className="enIconBtn mr-3 action_icon_padding"
                  >
                    <Image
                      src={require("../../../../../assets/images/superadmin/ordericon/view.svg")}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </Button>{" "}
                </div>
              </Col>
              <Col md={3}></Col>
            </Row>
          </div>
          <div style={{marginTop : "2%"}}>
            <h4>Updated Location : 01.25 Miles</h4>
            <br />
            <hr />
            <br />
            *******Location Map*******
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default OrderLocation;
